module.exports = __webpack_public_path__ + "images/emoji/cupid.119b995f5a570ec73142.png";